const TEAM_MEMBER_IMAGE_CROP_SHAPE = 'rect';
const TEAM_MEMBER_IMAGE_OUTPUT_WIDTH = 900;
const TEAM_MEMBER_IMAGE_OUTPUT_HEIGHT = 1100;
const TEAM_MEMBER_IMAGE_CROP_FRAME_SIZE = 280;

const DEFAULT_TEAM_MEMBERS = [
  {
    id: 'default-1',
    name: 'Zouhair Essid',
    gender: 'male',
    role: 'Founder',
    roleI18n: { en: 'Founder', fr: 'Fondateur' },
    imageUrl: '/team/1.webp',
    sortOrder: 1,
  },
  {
    id: 'default-2',
    name: 'Mohamed Rafik Essid',
    gender: 'male',
    role: 'Ceo',
    roleI18n: { en: 'Ceo', fr: 'PDG' },
    imageUrl: '/team/2.webp',
    sortOrder: 2,
  },
  {
    id: 'default-3',
    name: 'Abdelkrim Bellahirech',
    gender: 'male',
    role: 'Storekeeper',
    roleI18n: { en: 'Storekeeper', fr: 'Magasinier' },
    imageUrl: '/team/3.webp',
    sortOrder: 3,
  },
  {
    id: 'default-4',
    name: 'Ramzi Zamni',
    gender: 'male',
    role: 'Sales Director',
    roleI18n: { en: 'Sales Director', fr: 'Directeur commercial' },
    imageUrl: '/team/4.webp',
    sortOrder: 4,
  },
  {
    id: 'default-5',
    name: 'Mohamed El Hammami',
    gender: 'male',
    role: 'Commercial Agent',
    roleI18n: { en: 'Commercial Agent', fr: 'Agent commercial' },
    imageUrl: '/team/5.webp',
    sortOrder: 5,
  },
  {
    id: 'default-6',
    name: 'Sana Bellalah',
    gender: 'female',
    role: 'Purchasing and Supply Manager',
    roleI18n: {
      en: 'Purchasing and Supply Manager',
      fr: "Responsable d'achats et d'approvisionnement",
    },
    imageUrl: '/team/6.webp',
    sortOrder: 6,
  },
  {
    id: 'default-7',
    name: 'Bassem Mathlouthi',
    gender: 'male',
    role: 'Workshop Manager',
    roleI18n: { en: 'Workshop Manager', fr: "Chef d'atelier SAV" },
    imageUrl: '/team/7.webp',
    sortOrder: 7,
  },
];

function normalizeGender(value = '') {
  const normalized = String(value || '')
    .trim()
    .toLowerCase();
  if (['male', 'm', 'man', 'mr', 'mr.', 'sir'].includes(normalized)) return 'male';
  if (['female', 'f', 'woman', 'mrs', 'mrs.', 'miss', 'ms'].includes(normalized)) return 'female';
  return '';
}

function normalizeRoleI18n(roleI18n = {}) {
  return {
    en: String(roleI18n?.en || '').trim(),
    fr: String(roleI18n?.fr || '').trim(),
  };
}

function normalizeSortOrder(value) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

function normalizeTeamMemberBioText(payload = {}) {
  return String(payload.bio || payload.description || '').trim();
}

function normalizeTeamMemberBioI18n(payload = {}, fallbackText = '') {
  const fallback = String(fallbackText || '').trim();
  const source = payload?.bioI18n && typeof payload.bioI18n === 'object' ? payload.bioI18n : payload || {};
  const en = String(source?.en || source?.english || fallback).trim();
  const fr = String(source?.fr || source?.french || fallback || en).trim();
  return {
    en,
    fr: fr || en,
  };
}

function getBioValueForLanguage(bioI18n = {}, bio = '', language = 'en') {
  const normalizedLanguage = String(language || 'en').trim().toLowerCase();
  if (normalizedLanguage.startsWith('fr')) {
    return String(bioI18n?.fr || bioI18n?.en || bio || '').trim();
  }
  return String(bioI18n?.en || bioI18n?.fr || bio || '').trim();
}

function normalizeTeamMemberPayload(payload = {}) {
  const bioText = normalizeTeamMemberBioText(payload);
  const bioI18n = normalizeTeamMemberBioI18n(payload, bioText);
  return {
    name: String(payload.name || '').trim(),
    gender: normalizeGender(payload.gender),
    role: String(payload.role || '').trim(),
    bio: bioI18n.en || bioText,
    bioI18n,
    roleI18n: normalizeRoleI18n(payload.roleI18n || {}),
    imageUrl: String(payload.imageUrl || '').trim(),
    sortOrder: normalizeSortOrder(payload.sortOrder),
  };
}

function serializeTeamMember(member) {
  if (!member || typeof member !== 'object') return null;
  const item = typeof member.toObject === 'function' ? member.toObject() : member;
  return {
    _id: item?._id ? String(item._id) : '',
    name: String(item?.name || '').trim(),
    gender: normalizeGender(item?.gender || ''),
    role: String(item?.role || '').trim(),
    bio: getBioValueForLanguage(normalizeTeamMemberBioI18n(item, normalizeTeamMemberBioText(item)), String(item?.bio || item?.description || '')),
    bioI18n: normalizeTeamMemberBioI18n(item, normalizeTeamMemberBioText(item)),
    description: normalizeTeamMemberBioText(item),
    roleI18n: normalizeRoleI18n(item?.roleI18n || {}),
    imageUrl: String(item?.imageUrl || '').trim(),
    sortOrder: normalizeSortOrder(item?.sortOrder),
    createdAt: item?.createdAt ? new Date(item.createdAt).toISOString() : null,
    updatedAt: item?.updatedAt ? new Date(item.updatedAt).toISOString() : null,
  };
}

function getLocalizedTeamRole(member, language = 'en') {
  const normalizedLanguage = String(language || 'en').trim().toLowerCase();
  const role = String(member?.role || '').trim();
  const roleI18n = normalizeRoleI18n(member?.roleI18n || {});
  if (normalizedLanguage.startsWith('fr')) {
    return roleI18n.fr || roleI18n.en || role;
  }
  return roleI18n.en || role || roleI18n.fr;
}

function getLocalizedTeamHonorific(member, language = 'en') {
  const gender = normalizeGender(member?.gender || '');
  const normalizedLanguage = String(language || 'en').trim().toLowerCase();
  if (gender === 'male') {
    return normalizedLanguage.startsWith('fr') ? 'M.' : 'Mr.';
  }
  if (gender === 'female') {
    return normalizedLanguage.startsWith('fr') ? 'Mme' : 'Ms.';
  }
  return '';
}

function getLocalizedTeamDisplayName(member, language = 'en') {
  const name = String(member?.name || '').trim();
  const honorific = getLocalizedTeamHonorific(member, language);
  return honorific && name ? `${honorific} ${name}` : name;
}

function sortTeamMembers(items = []) {
  return [...items].sort((a, b) => {
    const orderA = normalizeSortOrder(a?.sortOrder);
    const orderB = normalizeSortOrder(b?.sortOrder);
    if (orderA !== orderB) return orderA - orderB;
    const createdAtA = new Date(a?.createdAt || 0).getTime();
    const createdAtB = new Date(b?.createdAt || 0).getTime();
    if (createdAtA !== createdAtB) return createdAtA - createdAtB;
    return String(a?.name || '').localeCompare(String(b?.name || ''));
  });
}

function getTeamMemberOrderSignature(items = []) {
  return (Array.isArray(items) ? items : [])
    .map((item) => String(item?._id || item?.id || item?.name || '').trim())
    .join('|');
}

function rotateTeamMembers(items = [], offset = 1) {
  const list = Array.isArray(items) ? [...items] : [];
  if (list.length < 2) return list;
  const normalizedOffset = ((Number(offset) || 0) % list.length + list.length) % list.length;
  if (normalizedOffset === 0) return list;
  return [...list.slice(normalizedOffset), ...list.slice(0, normalizedOffset)];
}

function shuffleTeamMembers(items = [], previousSignature = '') {
  const list = Array.isArray(items) ? [...items] : [];
  if (list.length < 2) return list;

  const originalSignature = getTeamMemberOrderSignature(list);
  for (let index = list.length - 1; index > 0; index -= 1) {
    const swapIndex = Math.floor(Math.random() * (index + 1));
    [list[index], list[swapIndex]] = [list[swapIndex], list[index]];
  }

  const shuffledSignature = getTeamMemberOrderSignature(list);
  if (shuffledSignature !== originalSignature && shuffledSignature !== previousSignature) {
    return list;
  }

  const rotateOffset = Math.max(1, Math.floor(Math.random() * list.length));
  const rotated = rotateTeamMembers(list, rotateOffset);
  if (getTeamMemberOrderSignature(rotated) !== previousSignature) return rotated;
  return rotateTeamMembers(rotated, 1);
}

function getNextTeamSortOrder(items = []) {
  const orders = Array.isArray(items)
    ? items
        .map((item) => normalizeSortOrder(item?.sortOrder))
        .filter((value) => Number.isFinite(value))
    : [];
  const maxOrder = orders.length > 0 ? Math.max(...orders) : 0;
  return Math.max(maxOrder + 1, 1);
}

function applyTeamMemberOrder(items = []) {
  return (Array.isArray(items) ? items : []).map((item, index) => ({
    ...item,
    sortOrder: index + 1,
  }));
}

module.exports = {
  DEFAULT_TEAM_MEMBERS,
  TEAM_MEMBER_IMAGE_CROP_SHAPE,
  TEAM_MEMBER_IMAGE_OUTPUT_WIDTH,
  TEAM_MEMBER_IMAGE_OUTPUT_HEIGHT,
  TEAM_MEMBER_IMAGE_CROP_FRAME_SIZE,
  normalizeRoleI18n,
  normalizeSortOrder,
  normalizeGender,
  normalizeTeamMemberBioI18n,
  normalizeTeamMemberPayload,
  serializeTeamMember,
  getBioValueForLanguage,
  getLocalizedTeamRole,
  getLocalizedTeamHonorific,
  getLocalizedTeamDisplayName,
  sortTeamMembers,
  getTeamMemberOrderSignature,
  shuffleTeamMembers,
  getNextTeamSortOrder,
  applyTeamMemberOrder,
};
